import * as planAction from "./planAction";

export const planFeatureKey = "planInfo";

const initialState = {
  loading: false,
  errorMsg: "",
  plans: [],
  comparisonFeatures: [],
  comparisonFeaturesLoading: false,
  couponCode: null,
  couponCodeLoading: false,
  paymentIntent: null,
  paymentIntentLoading: false,
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case planAction.GET_PLAN_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case planAction.GET_PLAN_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: payload.data,
      };
    case planAction.GET_PLAN_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };

    case planAction.MAKE_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case planAction.MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case planAction.MAKE_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };

    case planAction.SET_PLAN_EXPIRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case planAction.SET_PLAN_EXPIRY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case planAction.SET_PLAN_EXPIRY_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };

    case planAction.GET_COMPARISON_FEATURES_REQUEST:
      return {
        ...state,
        comparisonFeaturesLoading: true,
      };
    case planAction.GET_COMPARISON_FEATURES_SUCCESS:
      return {
        ...state,
        comparisonFeaturesLoading: false,
        comparisonFeatures: payload.data,
      };
    case planAction.GET_COMPARISON_FEATURES_FAILURE:
      return {
        ...state,
        comparisonFeaturesLoading: false,
        errorMsg: payload,
      };
    case planAction.CHECK_COUPON_CODE_REQUEST:
      return {
        ...state,
        couponCodeLoading: true,
      };
    case planAction.CHECK_COUPON_CODE_SUCCESS:
      return {
        ...state,
        couponCodeLoading: false,
        couponCode: payload.data,
      };
    case planAction.CHECK_COUPON_CODE_FAILURE:
      return {
        ...state,
        couponCodeLoading: false,
        errorMsg: payload,
      };
    case planAction.PAYMENT_INTENT_REQUEST:
      return {
        ...state,
        paymentIntentLoading: true,
      };
    case planAction.PAYMENT_INTENT_SUCCESS:
      return {
        ...state,
        paymentIntentLoading: false,
        paymentIntent: payload.data,
      };
    case planAction.PAYMENT_INTENT_FAILURE:
      return {
        ...state,
        paymentIntentLoading: false,
        errorMsg: payload,
      };

    case planAction.CLEAR_PAYMENT_INTENT:
      return {
        ...state,
        paymentIntent: null,
      };
    default:
      return state;
  }
};
